var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBilditLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 30,
    viewBox: "0 0 134 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_928_2292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5047 14.7448C22.0335 14.1019 24.3143 11.5735 24.3143 7.75936C24.3143 3.00243 20.6134 0.00256348 14.7177 0.00256348H0V30.0012H15.062C21.0007 30.0012 24.7877 26.7871 24.7877 21.7302C24.7877 17.7446 22.2056 15.1733 18.5047 14.7448ZM11.7914 5.74516C14.0291 5.74516 15.3632 6.90226 15.3632 8.8736C15.3632 10.8449 13.9861 12.0877 11.7914 12.0877H8.9511V5.74516H11.7914ZM8.9511 23.7872V17.2732H12.0496C14.2443 17.2732 15.6644 18.5589 15.6644 20.4874C15.6644 22.5016 14.2873 23.7872 12.0065 23.7872H8.9511Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4024 30.0012V0.00256348H28.4513V30.0012H37.4024Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9332 30.0012V22.3301H51.6911V0.00256348H42.74V30.0012H61.9332Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6271 30.0012C88.0946 30.0012 94.2485 23.4444 94.2485 15.0019C94.2485 6.60227 88.0516 0.00256348 78.6271 0.00256348H66.1902V30.0012H78.6271ZM75.1413 7.28795H77.8525C82.3711 7.28795 84.9531 10.8021 84.9531 15.0019C84.9531 19.2017 82.3711 22.7158 77.8525 22.7158H75.1413V7.28795Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.576 29.9987V0H97.6245V29.9987H106.576Z",
    fill: "#ED1E79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.201 29.9987V7.67109H133.947V0H109.46V7.67109H117.206V29.9987H126.201Z",
    fill: "#ED1E79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_928_2292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133.947,
    height: 30.0012,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilditLogo);
export default __webpack_public_path__ + "static/media/BILDIT_logo.3a02803c0695a168a1f2b3a08022a7e4.svg";
export { ForwardRef as ReactComponent };